import { z } from 'zod';

export interface FingerprintResult {
    visitorId: string;
}

// Search data schema
export const searchSchema = z.object({
    siteId: z.number(),
    searchSite: z.string(),
    searchType: z.string(),
    searchFuzzy: z.boolean(),
    emailDisabled: z.boolean(),
    showCampus: z.boolean().default(false),
    visitorId: z.string().optional(),
});

export type SearchData = z.infer<typeof searchSchema>;

/**
 * AJAX search result schema
 */
export const searchResultSchema = z.array(z.object({
    title: z.string(),
    content: z.string(),
    link: z.url(),
    campus: z.string(),
    page_type: z.string(),
}));

export type SearchResult = z.infer<typeof searchResultSchema.element>;
